import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { GALLERY_NOTE, GARMENTS, OFFER_ANCHOR } from '../../data/collection';
import { primaryButtonClass } from '../../utils/buttonStyles';

/** Grid of 10 models (2 columns on phone/tablet, 3 on desktop). No carousel, no zoom. */
export function GallerySection() {
  return <section id="prendas" aria-labelledby="prendas-title" className="w-full bg-blush" data-id="element-213" data-mp="gyytxr6hizmj">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-8 lg:py-24" data-id="element-214" data-mp="gwm3epmnvgxv">
        <SectionHeading id="prendas-title" title="Mirá algunos de los modelos que podés confeccionar" intro="Elegí tu favorito: estos son 10 de los 31 modelos incluidos en la colección." data-id="element-215" data-mp="cvsg9yh1m661" />

        <ul className="mt-10 grid w-full grid-cols-2 gap-x-3 gap-y-7 sm:gap-x-5 sm:gap-y-9 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-12" data-id="element-216" data-mp="31imcccgczt7">
          {GARMENTS.map((garment, index) => <li key={garment.image.src} className="min-w-0" data-id="element-217" data-mp="1xe02kzyvizoc" data-mpi={index}>
              <figure className="flex w-full min-w-0 flex-col" data-id="element-218" data-mp="n6yyajppb76j">
                <div className="overflow-hidden rounded-[14px] bg-paper ring-1 ring-blush-deep sm:rounded-[18px]" data-id="element-219" data-mp="r8tzlo7mtkkb">
                  <img src={garment.image.src} alt={garment.image.alt} width={garment.image.width} height={garment.image.height} loading={index < 2 ? 'eager' : 'lazy'} fetchPriority="low" decoding="async" sizes="(min-width: 1024px) 360px, 50vw" className="block aspect-square h-auto w-full object-contain" data-id="element-220" data-mp="d9avd6hxytda" />
                </div>
                <figcaption className="mt-3 min-w-0 sm:mt-4" data-id="element-221" data-mp="115yer4328frm">
                  <span className="block break-words font-serif text-[1.05rem] font-semibold leading-snug text-graphite sm:text-[1.3rem] lg:text-[1.4rem]" data-id="element-222" data-mp="1owucehu7656s">
                    {garment.title}
                  </span>
                  <span className="mt-1 block text-[0.88rem] font-semibold text-sage-ink sm:text-[1rem]" data-id="element-223" data-mp="23jsydxaac7e4">
                    {garment.caption}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>

        <p className="mt-8 max-w-2xl text-[0.92rem] leading-relaxed text-graphite-soft" data-id="element-224" data-mp="1tmy4jroyiv66">{GALLERY_NOTE}</p>

        <div className="mt-6" data-id="element-225" data-mp="1plus7f64bh9p">
          <a href={OFFER_ANCHOR} className={primaryButtonClass('lg')} data-id="element-226" data-mp="1kkov755fd7ud">
            Quiero la colección completa
            <ArrowDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden data-id="element-227" data-mp="1fsnlnqzn5v81" />
          </a>
        </div>
      </div>
    </section>;
}